import { addDays, differenceInDays } from 'date-fns';
import { MealCreditInfoTextProps } from './constructMealCreditInfoText.utils';

export function getCurrentPeriodStartDate(
  props: Pick<MealCreditInfoTextProps, 'startDate' | 'refreshPeriodDaysCount'>
): Date {
  const { startDate, refreshPeriodDaysCount } = props;
  const daysDifference = differenceInDays(new Date(), startDate);
  const currentPeriodCount = Math.floor(
    daysDifference / refreshPeriodDaysCount
  );
  const currentStartDate = addDays(
    startDate,
    currentPeriodCount * refreshPeriodDaysCount
  );

  return currentStartDate;
}
